/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_52ae8796","_52ae8796",""]'><div :class='["","_52ae8796",""]'><div :class='["","_52ae8796",""]'>switch-text 属性修改展示、收起文案</div><div :class='["bg-white","_52ae8796",""]'><cube-collapse :switch-text="(switchText)" :class='["","_52ae8796",""]'><div :class='["","_52ae8796",""]'>内容文案，第一行</div><div :class='["","_52ae8796",""]'>内容文案，第二行</div><div :class='["","_52ae8796",""]'>内容文案，第三行</div><div :class='["","_52ae8796",""]'>内容文案，第四行</div></cube-collapse></div><div :class='["","_52ae8796",""]'>switch-text 也可以是字符串</div><div :class='["bg-white","_52ae8796",""]'><cube-collapse :switch-text="('如何做到早睡早起？')" :class='["","_52ae8796",""]'><div :class='["","_52ae8796",""]'>1. 吃好喝好</div><div :class='["","_52ae8796",""]'>2. 睡前少玩手机</div><div :class='["","_52ae8796",""]'>3. 定闹钟早起</div><div :class='["","_52ae8796",""]'>4. 上面的理论来自个人猜想</div></cube-collapse></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"scoped":true,"mid":"_52ae8796"}'>
.bg-white
  margin-top: 6px
  background-color: #fff
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_52ae8796"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_52ae8796"}
  /** script content **/
  require("./change-switch-text.mpx.js?isComponent&outputPath=components%2Fchange-switch-text52ae8796%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./change-switch-text.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fchange-switch-text52ae8796%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_52ae8796"],
    ctorType: "component",
    outputPath: "components/change-switch-text52ae8796/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-collapse':getComponent(require("../../../packages/mpx-cube-ui/src/components/collapse/index.mpx?isComponent&outputPath=components%2Findex5127b398%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>